import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

const API_BASE_URL = 'https://myreadyroom-api-crchhghhctcvgagq.westus2-01.azurewebsites.net';

export default function Register() {
  const navigate = useNavigate();
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await axios.post(`${API_BASE_URL}/api/auth/register`, { fullName, email, password });
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      navigate('/home');
    } catch {
      setError('Email may already be in use');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <p style={styles.brand}>VIRILITER</p>
        <h1 style={styles.title}>Create Account</h1>
        <p style={styles.subtitle}>My Ready Room — Executive Prep</p>

        <form onSubmit={handleRegister} style={styles.form}>
          <p style={styles.label}>YOUR DETAILS</p>
          {error && <p style={styles.error}>{error}</p>}
          <input
            style={styles.input}
            type="text"
            placeholder="Full name"
            value={fullName}
            onChange={e => setFullName(e.target.value)}
            required
          />
          <input
            style={styles.input}
            type="email"
            placeholder="Email address"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
          <input
            style={styles.input}
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? 'Creating account...' : 'Create Account'}
          </button>
        </form>

        <p style={styles.link}>
          Already have an account?{' '}
          <Link to="/" style={styles.linkAccent}>Sign In</Link>
        </p>
        <p style={styles.footer}>Train for the moment that defines your career.</p>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: { minHeight: '100vh', backgroundColor: '#0A0F1E', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' },
  card: { width: '100%', maxWidth: '420px', display: 'flex', flexDirection: 'column', gap: '16px' },
  brand: { color: '#3B82F6', fontSize: '11px', letterSpacing: '6px', fontWeight: '700', textAlign: 'center', margin: 0 },
  title: { color: '#F1F5F9', fontSize: '34px', fontWeight: '800', textAlign: 'center', margin: 0, letterSpacing: '-0.5px' },
  subtitle: { color: '#475569', fontSize: '13px', textAlign: 'center', margin: 0 },
  form: { display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '8px' },
  label: { color: '#3B82F6', fontSize: '10px', letterSpacing: '4px', fontWeight: '700', margin: 0 },
  error: { color: '#EF4444', fontSize: '14px', margin: 0 },
  input: { backgroundColor: '#0F172A', color: '#F1F5F9', padding: '16px', borderRadius: '12px', fontSize: '16px', border: '1px solid #1E293B', outline: 'none', width: '100%', boxSizing: 'border-box' },
  button: { backgroundColor: '#3B82F6', color: '#ffffff', padding: '18px', borderRadius: '12px', fontSize: '16px', fontWeight: '700', border: 'none', cursor: 'pointer', width: '100%' },
  link: { color: '#475569', textAlign: 'center', fontSize: '14px', margin: 0 },
  linkAccent: { color: '#3B82F6', fontWeight: '600', textDecoration: 'none' },
  footer: { color: '#1E293B', textAlign: 'center', fontSize: '12px', margin: 0 },
};